<!------------------------------------------TITLE----------------------------------------------->
<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
  <div class="head-card p-1 inner-title-box">
    <h1 class="title-text text-center font-weight-bold">
      Our Projects and Experience
    </h1>
    <div class="text-right">
      <h5 class="text-light">
        <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;/&nbsp;
        <!-- <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
        <span class="sub-menu" routerLink="/clients"> Gallery</span>
      </h5>
    </div>
  </div>
</div>
<!--------------------------------------------------TITLE END-------------------------------------------->




<div class="container">
  <h3 class="text-center font-weight-bold" >As a Director:</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/neeenthanvannil.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I Direct a Song for Album - “Nee Enthan Vaanathil”,released in YouTube Channel RV PRODUCTIONS, in March 2023
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I Direct a Pilot film - “Theethum Nandrum Pirar Thara Vaara”, released in YouTube Channel RV PRODUCTIONS,in June 2024</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/theethunandrey.jpg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center " >Comming Soon.....</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/karupasamy.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I Direct a web series - “KARUPASAMY UNDIYAL”, Going to release 
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I Direct a ALBUM - “VANAVIL POOVE”, Going to release .
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/vanavilpoovey.jpg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" >As a Producer:</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/neeenthan.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I produced a song for Album - “Nee Enthan Vaanathil” released in YouTube Channel RV PRODUCTIONS, in March 2023
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I produced an awareness short film – “HELLO PRIYA” released in YouTube Channel RV PRODUCTIONS, April 2023
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/hellopriya.jpg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" >As a Assistant Director:</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/kodimullai.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I worked as a Assistant Director to
          Mr.SenthilKumaran, Devayani Rajkumar
          Production –“Kodi Mullai” Serial –Raj
          satellite Television-From 2010 to 2011.
          
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I worked as a Assistant Director to
          Mr.Ganesh, Cine Times Production–
          “Mutharam”Serial – SUN satellite Television -
          From 2011 to 2012.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/Muthaaram.png" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/mynamemangama.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I worked as a Assistant Director to Mr.Sakthivel,Actor Suresh Production –“My Name is Mangamma” Serial –Zee Tamil satellite Television-From 2011 to 2012
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I worked as a Assistant Director to
          Mr.Mohan,Cine Star Media Production –
          “Madipakkam Madhavan”Serial –
          Kalaingar satellite Television-From 2012 to
          2014</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/madipakam.png" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/chinapapa.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I worked as a Assistant Director to
          Mr.Sakthivel,Radhan Production– “Chinna
          Papa Periya Papa”Serial –SUNsatellite
          Television-From 2015 to 2015
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I worked as a Assistant Director to
          Mr.Mohan,Johny Production –“Darling
          Darling ”Serial –Zee Tamil satellite
          Television-From 2016 to 2016.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/darlinhdarling.jpg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/thanilakandam.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I worked as a Assistant Director to
          Mr.Sakthivel,VVR Production –“Thanila
          Kandam ” Movie –Released 2015.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" >As a Actor:</h3>
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I played a role in “Madipakkam Madhavan”
          serial –Kalaingar Satellite Television</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/Madipakkam_Madhavan_Kalaignar_TV_Comedy_Serial.png" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/chinapapa.jpg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>I played a role in “Chinna Papa Periya Papa”
          serial –SUN Satellite Television
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>I played a role in “Thannila Kandam”
          Movie</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/actorthanilakandam.jpg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <a class="text-center" href="../../assets/img/projects/K. GNANAGURU - PORTFOLIO.pdf" download="K. GNANAGURU - PORTFOLIO.pdf"><button class="btn service-btn  mt-3 pt-2 pb-2" >
    DOWNLOAD PDF
  </button></a>
  
</div>







<!------------------------------------------------mobileview---------------------------------------------------------------------------->

<div class="d-block d-sm-none">
  
  
    <h3 class="text-center font-weight-bold" >As a Director:</h3>
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/neeenthanvannil.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I Direct a Song for Album - “Nee Enthan Vaanathil”,released in YouTube Channel RV PRODUCTIONS, in March 2023
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
            <div class="image-section1">
        <img src="./../../assets/img/projects/theethunandrey.jpg" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I Direct a Pilot film - “Theethum Nandrum Pirar Thara Vaara”, released in YouTube Channel RV PRODUCTIONS,in June 2024</li>
        </ul>
      </div>

    </div>
    &nbsp;&nbsp;
    <h3 class="text-center " >Comming Soon.....</h3>
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/karupasamy.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I Direct a web series - “KARUPASAMY UNDIYAL”, Going to release 
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/vanavilpoovey.jpg" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I Direct a ALBUM - “VANAVIL POOVE”, Going to release .
            </li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <h3 class="text-center font-weight-bold" >As a Producer:</h3>
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/neeenthan.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I produced a song for Album - “Nee Enthan Vaanathil” released in YouTube Channel RV PRODUCTIONS, in March 2023
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/hellopriya.jpg" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I produced an awareness short film – “HELLO PRIYA” released in YouTube Channel RV PRODUCTIONS, April 2023
            </li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <h3 class="text-center font-weight-bold" >As a Assistant Director:</h3>
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/kodimullai.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I worked as a Assistant Director to
            Mr.SenthilKumaran, Devayani Rajkumar
            Production –“Kodi Mullai” Serial –Raj
            satellite Television-From 2010 to 2011.
            
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/Muthaaram.png" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I worked as a Assistant Director to
            Mr.Ganesh, Cine Times Production–
            “Mutharam”Serial – SUN satellite Television -
            From 2011 to 2012.</li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/mynamemangama.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I worked as a Assistant Director to Mr.Sakthivel,Actor Suresh Production –“My Name is Mangamma” Serial –Zee Tamil satellite Television-From 2011 to 2012
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/madipakam.png" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I worked as a Assistant Director to
            Mr.Mohan,Cine Star Media Production –
            “Madipakkam Madhavan”Serial –
            Kalaingar satellite Television-From 2012 to
            2014</li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/chinapapa.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I worked as a Assistant Director to
            Mr.Sakthivel,Radhan Production– “Chinna
            Papa Periya Papa”Serial –SUNsatellite
            Television-From 2015 to 2015
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/darlinhdarling.jpg" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I worked as a Assistant Director to
            Mr.Mohan,Johny Production –“Darling
            Darling ”Serial –Zee Tamil satellite
            Television-From 2016 to 2016.</li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/thanilakandam.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I worked as a Assistant Director to
            Mr.Sakthivel,VVR Production –“Thanila
            Kandam ” Movie –Released 2015.
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <h3 class="text-center font-weight-bold" >As a Actor:</h3>
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/Madipakkam_Madhavan_Kalaignar_TV_Comedy_Serial.png" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I played a role in “Madipakkam Madhavan”
            serial –Kalaingar Satellite Television</li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/chinapapa.jpg" alt="Image 1" />
      </div>
      <div class="list-section1">
        <ul>
          <li>I played a role in “Chinna Papa Periya Papa”
            serial –SUN Satellite Television
            </li>
          
        </ul>
      </div>
    </div>
    &nbsp;&nbsp;
    <div class="item1">
      <div class="image-section1">
        <img src="./../../assets/img/projects/actorthanilakandam.jpg" alt="Image 2" />
      </div>
      <div class="list-section1">
        <ul>
          
          <li>I played a role in “Thannila Kandam”
            Movie</li>
        </ul>
      </div>
      
    </div>
    &nbsp;&nbsp;
  
   <div class="mob-view-btn">
    <a class="text-center " href="../../assets/img/projects/K. GNANAGURU - PORTFOLIO.pdf" download="K. GNANAGURU - PORTFOLIO.pdf"><button class="btn service-btn  mt-3 pt-2 pb-2" >
      DOWNLOAD PDF
    </button></a></div>
    &nbsp;&nbsp;
</div>